<template>
  <Grid v-if="subscriptionLayout.length" gtc="1fr 1fr 1fr" gap="var(--r-space-sp)" class="widgets">
    <component
      :is="component.type"
      v-for="(component, index) of definition"
      :key="component.uid"
      :component="component"
      :entity="subscription"
      context-name="subscriptions"
      subcontext-name="price"
    >
      <template #widget-options>
        <q-btn flat round size="xs">
          <GearIcon :dark="darkCharts.includes(component.type)" />
          <RPopup :items="options" @popup-item="changeBoxContent($event, index)" />
        </q-btn>
      </template>
    </component>
  </Grid>

  <Grid v-else place-items="center" class="widgets">
    <q-spinner color="primary" size="2rem" />
  </Grid>
</template>

<script>
import * as apiTo from '@/modular-api'
// Libraries
import { mapGetters } from 'vuex'
import { uid } from 'quasar'
import { cloneDeep } from 'lodash'
// Components
import GearIcon from '@/ui/icons/GearIcon'
import RPopup from '@/ui/RPopup'

export default {
  components: {
    PriceDevelopmentInLocalCurrency: () => import('./charts/PriceDevelopmentInLocalCurrency'),
    PriceDevelopmentInOriginalCurrency: () => import('./charts/PriceDevelopmentInOriginalCurrency'),
    PriceIncreaseInPercentageInOriginalCurrencyComparedToAveragePriceIncrease: () =>
      import('./charts/PriceIncreaseInPercentageInOriginalCurrencyComparedToAveragePriceIncrease'),
    PriceDevelopmentInLocalCurrencyComparedToAveragePrice: () =>
      import('./charts/PriceDevelopmentInLocalCurrencyComparedToAveragePrice'),
    PriceVsForecastedPriceOriginalCurrency: () => import('./charts/PriceVsForecastedPriceOriginalCurrency'),
    GearIcon,
    RPopup
  },

  data: () => ({
    definition: [],
    defaultWidgets: [
      {
        uid: uid(),
        type: 'price-development-in-local-currency-compared-to-average-price',
        colspan: 4
      },
      {
        uid: uid(),
        type: 'price-development-in-original-currency',
        colspan: 4
      },
      {
        uid: uid(),
        type: 'price-increase-in-percentage-in-original-currency-compared-to-average-price-increase',
        colspan: 4
      }
    ]
  }),

  computed: {
    ...mapGetters('widgets', ['subscriptionLayout']),
    ...mapGetters('subscription-show', ['subscription']),

    options() {
      const index = this.subscriptionLayout.findIndex(s => s.name === 'price')
      const elements = this.subscriptionLayout[index].available_elements
      const filteredElements = elements.filter(el => el.enabled)

      return filteredElements.map(el => ({
        uid: el.id,
        label: el.name,
        name: el.slug
      }))
    },

    darkCharts() {
      return ['price-development-in-original-currency']
    }
  },

  watch: {
    subscriptionLayout: {
      handler: 'updateDefinition',
      immediate: true
    }
  },

  created() {
    this.$store.dispatch('widgets/getContext')
  },

  methods: {
    updateDefinition(newVal) {
      const index = newVal.findIndex(val => val.name === 'price')
      if (~index) {
        const definition = cloneDeep(newVal[index].definition)
        this.definition = definition.length ? definition : this.defaultWidgets
      }
    },

    changeBoxContent({ name }, index) {
      let cards = cloneDeep(this.definition)
      cards[index].type = name
      this.updateLayout(cards)
    },

    updateLayout(definition) {
      const id = this.subscriptionLayout.find(l => l.name === 'price').id
      apiTo.UPDATE_LAYOUT(id, { definition }).then(({ data }) => this.layoutUpdated(data.result))
    },

    layoutUpdated(data) {
      let layout = cloneDeep(this.subscriptionLayout)
      const index = layout.findIndex(l => l.id === data.id)
      if (~index) {
        layout[index] = data
        this.$store.commit('widgets/setSubscriptionLayout', layout)
      }
    }
  }
}
</script>
